import { api, wrappedCollectionFetcher } from "services/api.service";
import { defaultMovementAction } from "types/locationManagement/movementAction";
import { LocationManagementLocationType } from "types/locationManagement/locationType";
import { redirect } from "react-router-dom";
import { withActionErrorAlert } from "utils/withActionError";
import { withAuth } from "routes/utils/withAuth";

export const loader = withAuth(async () => {
  const locationTypesRes = await wrappedCollectionFetcher<LocationManagementLocationType>(
    "/location_management/location_types?page[size]=100",
  );
  const locationTypes = locationTypesRes.rows || [];
  return { action: defaultMovementAction, locationTypes };
});

export async function action({ request }: { request: Request }) {
  const formData = await request.formData();
  const res = await withActionErrorAlert(() =>
    api.request({
      method: "POST",
      url: `/location_management/movement_actions`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  );
  if (res?.status === 201) {
    return redirect("/movement-actions");
  }
  return res;
}
